<template>
   <v-select
        :items="items"
        box
        :value="value"
        item-text="label"
        @change="handleChange"
        return-object
        :label="label[$i18n.locale]"></v-select>
</template>

<script>
// import { mapGetters } from 'vuex'
import sumValues from './sum-values.js'
export default {
    props: ['value', 'label'],
    components: {
        
    },
    data() {
        return {
           items: sumValues
        }
    },
	methods: {
        handleChange (e) {
            this.$emit('input', e)
        }
	}
};
</script>
<style>

</style>